export default {

    apiAddOpsApplication(data) {
        return this.request(this.api().ADD_OPS_APPLICATION, data).exec().log().get();
    },

    apiGetOpsApplications(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_OPS_APPLICATIONS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiGetOpsApplicationCounts() {
        return this.request(this.api().GET_OPS_APPLICATION_COUNTS)
            .exec()
            .log()
            .mapresults((res) => {
                return {
                    data: res?.byStatus,
                    total: res?.total
                }
            })
            .get();
    },
    apiExportOpsApplication(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_OPS_APPLICATION, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },

    apiGetOpsApplicationById(urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().GET_OPS_APPLICATION_BY_ID,)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((res) => {
                return res
            })
            .get();
    },

    apiUpdateOpsApplication(data, urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().UPDATE_OPS_APPLICATION, data).urltransform(urldata).exec().log().get();
    },

    apiDeleteOpsApplication(urldata = mixins.params()) {

        return this.request(this.api().DELETE_OPS_APPLICATION)
            .urltransform(urldata)
            .exec().log().get();
    },

    apiOpsAssignApplication(data, urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().OPS_ASSIGN_APPLICATION, data).urltransform(urldata).exec().log().get();
    },
}